<!-- <div class="parallax"></div> -->
<div class="parallax_img" id="parallax_img"></div>

<portfolio-navigation></portfolio-navigation>

<main id="main">
    <div class="container coming-soon-container text-center px-md-4">
        <span>PORTFOLIO</span>
        <p class="mt-4 mb-5 p-0">A learning portfolio. Designed for you. Game-changing.</p>
        <!-- <img class="img-fluid" src="../../../../assets/images/backgrounds/coming-soon.jpg"> -->
    </div>
    <section id="module" class="module">
        <div class="container" *ngIf="series">

          <!-- App store and Play store banner -->
          <div class="p-4 row col-12 mx-auto my-1 my-md-4 apps-banner" style="background-color: #F2F2F2;">

            <div class="col-12 col-md-8 text-center text-md-left d-md-flex d-inline">

              <img class="pt-1 mr-2" src="../../../../assets/images/rectangle-drop.png" id="rectangle-drop" width="90" height="90">
              <div>
                <span style="font-size: 30px;font-weight: 600;">Download the app:</span><br>
                <span>Download your TaB Trainer and use the settings </span>
                <span class="clearfix d-none d-lg-block"></span>
                <span>to start your breathe training.</span>
              </div>

            </div>

            <div class="col-12 col-md-4 text-center text-md-right mt-3">
               <a target="_blank" href="https://apps.apple.com/us/app/take-a-breath/id1534039062" class="d-block d-md-inline">
                 <img class="pt-1" src="../../../../assets/images/logos/apple-badge.png" id="apple-badge" width="130">
               </a>
               <a target="_blank" href="https://play.google.com/store/apps/details?id=world.takeabreath.reminder">
                 <img class="pt-1" src="../../../../assets/images/logos/google-play-badge.png" id="google-badge" width="130">
               </a>
            </div>
          </div>

          <div id="dashboard-slider" class="my-5" style="display: flex;">
            <!-- left arrow button -->
            <div class="swiper-button-prev d-none d-md-block"></div>

            <!-- Swiper -->
            <swiper [config]="config" style="height: 100%; width: 100%;">
              <div class="swiper-wrapper">
                <div class="swiper-slide" *ngFor="let moduleObj of imageObject" [ngStyle]="{'opacity': (moduleObj.points == moduleObj.total) ? '0.5' : '1'}">
                  <a [routerLink]="['/user/videos/', moduleObj.seriesId, moduleObj.id]" [queryParams]="{video_active: true}">
                    <img width="100%" height="110" style="border-radius: 50% !important;" src="{{ moduleObj.image }}">
                    <div class="text-center mt-2" style="color:#21344C">
                      <span>Module {{ moduleObj.module }}</span><br>
                      <span *ngIf="moduleObj.points != moduleObj.total"> {{ moduleObj.points }}/{{ moduleObj.total }} Points</span>
                      <span *ngIf="moduleObj.points == moduleObj.total"><img class='module-badge-icon' src='../../../../assets/images/icons/award_dark.svg'></span>
                    </div>
                  </a>
                </div>
              </div>
            </swiper>

            <!-- right arrow button -->
            <div class="swiper-button-next d-none d-md-block"></div>
          </div>

            <div *ngFor="let list of series; let seriesIndex = index" data-aos="fade-up">
                <ng-container *ngIf="list.modules.length > 0">
                    <div class="section-title text-left text-md-center mx-2 mx-md-0 mx-lg-0">
                        <span>{{ 'Series ' + list.sequence_number }}</span>
                        <p class="ml-0 pb-0 mt-md-3">{{ list.series_name }}</p>
                    </div>

                    <div class="row module-container justify-content-center" data-aos="fade-up" data-aos-delay="200">
                        <div *ngFor="let module of list.modules" class="col-md-6 col-lg-6 col-xl-4 module-item">

                            <a [routerLink]="['/user/videos/', list.series_id, module.id]" [queryParams]="{video_active: true}">
                            <div class="module-wrap">
                                <!-- <a [routerLink]="['/user/videos/', list.series_id, module.id]" [queryParams]="{video_active: true}"> -->
                                    <div class="d-flex justify-content-center align-item-center">
                                        <img
                                            [defaultImage]="preloaderImage"
                                            [lazyLoad]="module.cover_url"
                                            class="module-image"
                                            [id]="'module_image_' + list.id + '_' + module.id"
                                            (onStateChange)="moduleImageCallback($event, list.id, module.id)"
                                        >
                                    </div>
                                    <div
                                        class="badge-points d-none py-1 px-2"
                                        [id]="'module_badge_points_' + list.id + '_' + module.id"
                                    >
                                        <img class="module-badge-icon" src="../../../../assets/images/icons/award.svg">
                                        <span class="d-inline-block align-middle ml-1 ml-md-1 badge-text">
                                        {{ module.points ? module.points : '0' }}
                                        / {{ module.totalAvailablePoints }} points</span>
                                    </div>
                                    <div [id]="'module_play_' + list.id + '_' + module.id" class="d-none justify-content-center align-items-middle">
                                        <!--
                                        <img src="../../../../assets/images/icons/play.svg">
                                        -->
                                    </div>
                                <!-- </a> -->
                                <div class="module-info" [ngStyle]="{'background-color': '#' + module.cover_color}">
                                    <div
                                        class="badge-videos d-none py-1 px-2"
                                        *ngIf="module.video_completed; else notWatched"
                                        [id]="'module_badge_video_' + list.id + '_' + module.id"
                                    >
                                        <img class="module-badge-icon" src="../../../../assets/images/icons/check.svg">
                                        <span class="d-inline-block align-middle ml-1 ml-md-1 badge-text">Watched</span>
                                    </div>
                                    <ng-template #notWatched>
                                        <div
                                            class="badge-videos d-none py-1 px-2"
                                            [id]="'module_badge_video_duration_' + list.id + '_' + module.id"
                                        >
                                            <img class="module-badge-icon" src="../../../../assets/images/icons/video_time.svg">
                                            <span class="d-inline-block align-middle ml-1 ml-md-1 badge-text">{{ module.video_duration }}</span>
                                        </div>
                                    </ng-template>

                                    <span class="module-number">{{ 'Module ' + module.moduleNo }}</span>
                                    <h4>{{ module.name }}</h4>
                                    <p class="mb-0">{{ module.description }}</p>
                                </div>
                            </div>
                            </a>

                        </div>
                    </div>

                </ng-container>
            </div>
        </div>

        <!-- Modal Loader -->
        <modal-loader [modalText]="modalText"></modal-loader>

    </section>
</main>

<footer-main *ngIf="series"></footer-main>
